import styles from './orderInfo.module.css';
import {
    Icon,
    IconSizes,
    Icons,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {useI18nContext} from '../../i18n/i18n-react';
import formatDateTime from '../../utils/formatDateTime';
import {Order} from '../../models/order';
import OrderInfoLoader from './orderInfoLoader';

interface OrderInfoProps {
    order: Order | null;
}

const OrderInfo = ({order}: OrderInfoProps) => {
    const {LL} = useI18nContext();

    if (!order) {
        return (
            <>
                <Typography variant={'h6'}>Bestelgegevens</Typography>
                <div className={styles.container}>
                    <OrderInfoLoader />
                </div>
            </>
        );
    }

    return (
        <>
            <Typography variant={'h6'}>Bestelgegevens</Typography>
            <div className={styles.container}>
                {order.createdAt && (
                    <div className={styles.text}>
                        <Typography size={'s'}>
                            {LL.order.date()}
                            {': '}
                        </Typography>
                        <Typography size={'s'}>
                            {formatDateTime(order.createdAt)}
                        </Typography>
                    </div>
                )}
                {order.orderNumber && (
                    <div className={styles.text}>
                        <Typography size={'s'}>
                            {LL.order.number()}
                            {': '}
                        </Typography>
                        <Typography size={'s'}>{order.orderNumber}</Typography>
                    </div>
                )}
                {order.isCanceled && (
                    <div className={styles.text}>
                        <Typography size={'s'}>Status: </Typography>
                        <Icon
                            icon={Icons.CROSS}
                            color={'red'}
                            size={IconSizes.S}
                        />
                        <Typography size={'s'}>
                            {LL.order.state.canceled.title()}
                        </Typography>
                    </div>
                )}
                {!order.isCanceled && !order.isRefunded && !order.isPaid && (
                    <div className={styles.text}>
                        <Typography size={'s'}>Status: </Typography>
                        <Icon
                            icon={Icons.CIRCLE}
                            color={'blue'}
                            size={IconSizes.S}
                        />
                        <Typography size={'s'}>
                            {LL.order.state.pendingPayment.title()}
                        </Typography>
                    </div>
                )}

                {order.isPaid && (
                    <div className={styles.text}>
                        <Typography size={'s'}>Status: </Typography>
                        <Icon
                            icon={Icons.CHECK_BOX_FULL}
                            color={'green'}
                            size={IconSizes.S}
                        />
                        <Typography size={'s'}>
                            {LL.order.state.paid.title()}
                        </Typography>
                    </div>
                )}
                {order.isRefunded && (
                    <div className={styles.text}>
                        <Typography size={'s'}>Status: </Typography>
                        <Icon
                            icon={Icons.CHECK_BOX_FULL}
                            color={'green'}
                            size={IconSizes.S}
                        />
                        <Typography size={'s'}>
                            {LL.order.state.refunded.title()}
                        </Typography>
                    </div>
                )}
            </div>
        </>
    );
};

export default OrderInfo;
